"use client";

import config from "@/app.config";
import Image from "next/image";
import Link from "next/link";
import SocialMedia from "./social-media";
import { useMediaQuery } from "@mui/material";
import routes from "@/app.route";

export default function Footer() {
  const matches = useMediaQuery("(min-width:1024px)");

  if (!matches) return null;

  return (
    <>
      <footer className="bg-zinc-900 text-xs">
        <div className="max-w-8xl mx-auto px-4">
          <div className="grid grid-cols-12 gap-x-12 py-12">
            <div className="col-span-7 grid grid-cols-4 gap-6">
              <section>
                <div className="mb-3 font-medium text-zinc-200 uppercase">
                  About
                </div>
                <div className="flex flex-col items-start gap-y-1 text-white">
                  <Link href={routes.contact.url}>Contact Us</Link>
                </div>
              </section>
              <section>
                <div className="mb-3 font-medium text-zinc-200 uppercase">
                  Downloads
                </div>
                <div className="flex flex-col items-start gap-y-1 text-white">
                  <Link href={routes.download.url}>Apps</Link>
                </div>
              </section>
              <section>
                <div className="mb-3 font-medium text-zinc-200 uppercase">
                  Help
                </div>
                <div className="flex flex-col items-start gap-y-1 text-white">
                  <Link href={routes.delivery.url}>Shipping</Link>
                  <Link href={routes.return.url}>Return & Exchange</Link>
                </div>
              </section>
              <section>
                <div className="mb-3 font-medium text-zinc-200 uppercase">
                  Consumer policy
                </div>
                <div className="flex flex-col items-start gap-y-1 text-white">
                  <Link href={routes.refunds.url}>Refund Policy</Link>
                  <Link href={routes.terms.url}>Terms & Conditions</Link>
                  <Link href={routes.privacy.url}>Privacy Policy</Link>
                  <Link href="/sitemap.xml">Sitemap</Link>
                </div>
              </section>
            </div>

            <div className="col-span-5 grid grid-cols-2 gap-6">
              <section>
                <div className="mb-3 font-medium text-zinc-200">Social:</div>
                <div className="text-white">
                  <SocialMedia />
                </div>
              </section>

              {/* <section>
                <div className="mb-3 font-medium text-zinc-200">
                  Head Office Address:
                </div>
                <div className="text-white">
                  <p>4th floor, 330, 27th Main Rd, opp. to union bank, </p>
                  <p>Parangi Palaya, Sector 2, HSR Layout,</p>
                  <p>Bengaluru, 560102,</p>
                  <p>Karnataka, India</p>
                </div>
              </section> */}
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-between border-t border-zinc-700 px-6 py-6 text-white">
            <div className="px-6">
              <span>Technology Partner </span>
              <a href="https://phintella.com" className="font-semibold">
                Phintella
              </a>
            </div>
            <div className="px-6">
              &copy; 2022-{new Date().getFullYear()} {config.app.name} All
              Rights Reserved.
            </div>
            <div className="px-6 flex gap-x-3 items-center">
              {/* <Image
                src="/images/phonepe-logo.svg"
                width={230}
                height={70}
                alt="PhonePe"
                className="w-24"
              /> */}
              {/* <Image
                src="/images/razorpay-logo.png"
                width={640}
                height={136}
                alt="Razorpay"
                className="w-24"
              /> */}
              <Image
                src="/images/payu-logo.svg"
                width={625}
                height={341}
                alt="PayU"
                className="w-12"
                style={{ filter: "invert(1) hue-rotate(180deg)" }}
              />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
